module.exports = __webpack_public_path__ + "static/media/error_ghost.73edef77.svg";